import { render, staticRenderFns } from "./TextSection.vue?vue&type=template&id=3abc1a9e&scoped=true&"
import script from "./TextSection.vue?vue&type=script&lang=ts&"
export * from "./TextSection.vue?vue&type=script&lang=ts&"
import style0 from "./TextSection.vue?vue&type=style&index=0&id=3abc1a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc1a9e",
  null
  
)

export default component.exports